import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faCalendarDays, faCircleExclamation, faEye, faFileExcel, faFilePdf, faMagnifyingGlass, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { Subscription } from 'rxjs';
import { UsageHistoryService } from 'src/app/services/usage-history.service';
import { ModalHistoricoUtilizacaoComponent } from 'src/app/shared/modals/modal-historico-utilizacao/modal-historico-utilizacao.component';
import { ServiceStatus } from 'src/app/shared/models/saude/service-status';
import { DataService } from 'src/app/shared/services/data.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { HealthService } from '../../../services/saude/health.service';
@Component({
  selector: 'app-historico-utilizacao',
  templateUrl: './historico-utilizacao.component.html',
  styleUrls: ['./historico-utilizacao.component.css']
})
export class HistoricoUtilizacaoComponent {
  today = new Date();
  faPdf = faFilePdf;
  faExcel = faFileExcel;
  subscription!: Subscription;
  serviceStatus!: ServiceStatus[];
  convenants!: any[];
  beneficiaries!: any[];
  usageHistory!: any[];
  beneficiary: any;
  cpfResponsavel: any;
  loading: boolean = false;
  loadingPdf: boolean = false;
  loadingCsv: boolean = false;
  dataLimiteInicial: any;
  dataLimiteFinal: any;
  dataInicial!: any;
  dataFinal: any;
  dataAtual: any;
  dataHoje: any;
  formGroup: FormGroup = new FormGroup({
    categoryId: new FormControl(null),
    convenantId: new FormControl(null),
    finalDate: new FormControl(null, [Validators.required]),
    initialDate: new FormControl(null, [Validators.required]),
    itemsPerPage: new FormControl(5),
    page: new FormControl(0),
    personCpf: new FormControl(null),
    serviceStatusId: new FormControl(null)
  });
  //Icones    
  faCalendarDays = faCalendarDays;
  faCircleExclamation = faCircleExclamation;
  faEye = faEye;
  faFilePdf = faFilePdf;
  faFileExcel = faFileExcel;
  faMagnifyingGlass = faMagnifyingGlass;
  faTriangleExclamation = faTriangleExclamation;
  myRequestsFilter: any = { itemsPerPage: 5, page: 0 };
  constructor(private bsLocaleService: BsLocaleService, private healthService: HealthService,
    private userService: UsuarioService, private data: DataService, private modalService: NgbModal, private usageHistoryService: UsageHistoryService) {
    this.bsLocaleService.use('pt-br');
    this.consultar();
    this.initForm();
    const dataAtual = new Date();
    // Obter componentes da data (ano, mês, dia)
    const ano = dataAtual.getFullYear();
    const mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2); // +1 porque os meses são indexados de 0 a 11
    const mesFinal = ('0' + (dataAtual.getMonth() - 1)).slice(-2); // +1 porque os meses são indexados de 0 a 11
    const dia = ('0' + dataAtual.getDate()).slice(-2);
    this.dataHoje = `${ano}/${mes}/${dia}`;
    this.dataFinal = `${ano}/${mesFinal}/${dia}`;
  }
  initForm() {
    // (res: any) => { this.serviceStatus = res; }
    this.healthService.getServiceStatus().subscribe(
      (res: any) => {
        this.serviceStatus = res;
      }
    );
    this.userService.getBeneficiaries().subscribe(
      (res: any) => {
        this.beneficiaries = res;
        this.cpfResponsavel = this.beneficiaries[0].id;
        this.formGroup.get('personCpf')?.setValue(this.beneficiaries[0].id);
        this.data.filter = this.formGroup.value;
      }
    );
  }
  consultar() {
    this.loading = !this.loading;
    //Validações
    this.healthService.getHistoryComplete(this.formGroup.value).subscribe((res: any) => {
      this.usageHistory = res.filter(
        (x: any) => x.cpf == this.formGroup.get('personCpf')?.value
      );
      this.beneficiary = this.usageHistory[0];
      this.loading = !this.loading;
    });
  }
  visualizarDetalhes(details: any) {
    const modalRef = this.modalService.open(ModalHistoricoUtilizacaoComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.details = details;
  }
  customSearchFn($event: any) {
    let search = $event.term
    if (typeof search === 'string' && search.length > 2) {
      this.usageHistoryService.getCovenants(search).subscribe((res: any) => {
        res.items.forEach((res: any) => {
          res.tradeName = res.tradeName.trim().toUpperCase();
        })
        this.convenants = res.items;
      })
    }
  }
  printPdf() {
    //Validações
    let filter = {
      categoryId: this.formGroup.get('categoryId')?.value,
      convenantId: this.formGroup.get('convenantId')?.value,
      initialDate: this.formGroup.get('finalDate')?.value ? this.formGroup.get('finalDate')?.value : this.dataFinal,
      finalDate: this.formGroup.get('initialDate')?.value ? this.formGroup.get('initialDate')?.value : this.dataHoje,
      itemsPerPage: this.formGroup.get('itemsPerPage')?.value,
      page: this.formGroup.get('page')?.value,
      personCpf: this.formGroup.get('personCpf')?.value,
      serviceStatusId: this.formGroup.get('serviceStatusId')?.value,
    };
    this.loadingPdf = true;
    this.healthService.getHistoryPdf(filter).subscribe({
      next: (data: Blob) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Historico de Despesas.pdf";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        this.loadingPdf = false;
      },
      error: (err: any) => {
        this.loadingPdf = false;
      }
    }
    );
  }
  printCsv() {
    this.loadingCsv = true;
    this.healthService.getHistoryCsv(this.formGroup.value).subscribe({
      next: (data: Blob) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Historico de Despesas.csv";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        this.loadingCsv = false;
      },
      error: (err: any) => {
        this.loadingCsv = false;
      }
    }
    );
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.myRequestsFilter.itemsPerPage = quantidade;
    this.formGroup.get('itemsPerPage')?.setValue(this.myRequestsFilter.itemsPerPage);
    //Validações
    this.healthService.getHistoryComplete(this.formGroup.value).subscribe((res: any) => {
      this.usageHistory = res.filter(
        (x: any) => x.cpf == this.formGroup.get('personCpf')?.value
      );
      this.beneficiary = this.usageHistory[0];
    });
  }
  onChangePagination(page: number) {
    this.myRequestsFilter.page = page;
    this.formGroup.get('page')?.setValue(this.myRequestsFilter.page);
    //Validações
    this.healthService.getHistoryComplete(this.formGroup.value).subscribe((res: any) => {
      this.usageHistory = res.filter(
        (x: any) => x.cpf == this.formGroup.get('personCpf')?.value
      );
      this.beneficiary = this.usageHistory[0];
    });
  }
}